<template>
  <Page
    :title="isNew ? 'neue Rechnung' : 'Rechnung ' + item.number"
    color="info"
  >
    <template slot="help"> </template>
    <template slot="extension">
      <v-tabs background-color="info darken-1" hide-slider>
        <v-toolbar color="info darken-1" dense>
          <v-btn text exact :to="abortTarget"
            ><v-icon left>mdi-arrow-left</v-icon>Abbrechen</v-btn
          >
        </v-toolbar>
      </v-tabs>
    </template>

    <v-row v-if="item">
      <v-col cols="12" md="6" lg="5" xl="5">
        <FinanceInvoiceForm v-model="item" @saved="saved" />
      </v-col>
      <v-col cols="12" md="6" lg="7" xl="7">
        <FinanceInvoiceDetailForm v-model="item" />
      </v-col>
    </v-row>
  </Page>
</template>

<script>
import { defineComponent } from "vue";
import FinanceInvoiceForm from "common/components/Finance/FinanceInvoiceForm.vue";
import FinanceInvoiceDetailForm from "common/components/Finance/FinanceInvoiceDetailForm.vue";
import { createInvoice, getIban } from "common/utils/finance.js";

export default defineComponent({
  components: {
    FinanceInvoiceForm,
    FinanceInvoiceDetailForm,
  },
  props: { id: {}, page: { type: String, default: "InvoicePending" } },
  data() {
    return {
      loading: false,
      item: createInvoice(),
      tolerance: true,
    };
  },
  computed: {
    abortTarget() {
      return this.isNew
        ? { name: "InvoicePending" }
        : { name: "InvoiceDetails", params: { id: this.item.id } };
    },
    isNew() {
      return !this.id;
    },
  },
  watch: {
    item: {
      handler() {
        if (this.isNew) {
          this.saveStorage();
        }
      },
      deep: true,
    },
  },
  methods: {
    removeStorage() {
      localStorage.removeItem("teacherInvoiceForm");
    },
    checkStorage() {
      return (
        localStorage.getItem("teacherInvoiceForm") != null &&
        localStorage.getItem("teacherInvoiceForm") != "undefined"
      );
    },
    loadStorage() {
      this.item = JSON.parse(localStorage.getItem("teacherInvoiceForm"));
    },
    saveStorage() {
      if (!this.loading) {
        localStorage.setItem("teacherInvoiceForm", JSON.stringify(this.item));
      }
    },
    async saved(newId) {
      this.removeStorage();
      this.$router.push({
        name: "InvoiceDetails",
        params: { id: newId },
      });
      this.$emit("update");
    },
  },
  async created() {
    this.loading = true;
    if (this.isNew) {
      // check for local storage and ask
      if (this.checkStorage()) {
        if (
          await this.$root.confirm({
            message:
              "Es ist eine ungespeicherte Rechnung verfügbar. Soll diese geladen werden?",
            color: "info",
            icon: "mdi-floppy",
          })
        ) {
          this.loadStorage();
        } else {
          this.item.schoolYear = (
            await this.apiList({
              resource: "common/schoolyear",
              query: `offsetpast=0&offsetfuture=0`,
            })
          )[0];

          this.item.iban = await getIban();
        }
      } else {
        const schoolYears = await this.apiList({
          resource: "common/schoolyear",
          query: `offsetpast=0&offsetfuture=0`,
        });

        this.item.schoolYear = schoolYears[0];

        this.item.iban = await getIban();
      }
    } else {
      this.item = await this.apiGet({
        resource: "finance/invoice",
        id: this.id,
      });

      this.$set(this.item, "nodetails", this.item.details.length == 0);
    }

    this.loading = false;
  },
});
</script>
